import { Component } from '@angular/core';
import { ContentComponent } from '../content/content';
import { HeaderComponent } from '../header/header';

@Component({
  selector: 'app-landing',
  standalone: true,
  imports: [HeaderComponent, ContentComponent],
  template: `
    <app-header></app-header>
    <app-content></app-content>
  `
})
export class LandingComponent {}

